import React from 'react';

/**
 * Button to quickly save the current search with an auto-generated name.
 * Shows a plus + bookmark icon.
 */
function QuickSaveButton({ onClick, loading = false, isSubscriber = false, label = null }) {
  const tooltip = isSubscriber 
    ? "Save this search" 
    : "Pro feature: Save searches. Click \"Get Pro\" to upgrade.";
  
  return (
    <button
      className={`quick-save-button ${loading ? 'loading' : ''}`}
      onClick={onClick}
      disabled={loading}
      title={tooltip}
      aria-label={tooltip}
    >
      {loading ? (
        <span className="quick-save-button__spinner" />
      ) : (
        <>
          {/* Plus + bookmark icon */}
          <svg 
            className="quick-save-button__icon" 
            width="18" 
            height="18" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2"
          >
            {/* Bookmark shape */}
            <path d="M17 21l-5-3.5L7 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2z" />
            {/* Plus sign */}
            <line x1="12" y1="8" x2="12" y2="14" />
            <line x1="9" y1="11" x2="15" y2="11" />
          </svg>
        </>
      )}
      {label && <span className="quick-save-button__label">{label}</span>}
    </button>
  );
}

export default QuickSaveButton;
